// Réponse à un mail archivé via le client mail du poste (lien mailto:) —
// aucune connexion de boîte requise, l'app ne fait qu'ouvrir le lien.
// Contraintes du standard mailto : corps en texte brut uniquement, et longueur
// d'URL plafonnée (~2083 sous Windows/Outlook) → l'historique est tronqué au besoin.

const MAX_MAILTO_LENGTH = 1900;
const TRUNCATION_NOTICE = '\n\n[Historique tronqué — mail complet dans le dossier]';

export interface ReplySource {
  from_email: string;
  subject: string | null;
  body_text: string | null;
  body_html: string | null;
  sent_at: string | null;
}

export function replySubject(subject: string | null): string {
  const s = (subject ?? '').trim();
  if (!s) return 'RE:';
  return /^re\s*:/i.test(s) ? s : `RE: ${s}`;
}

/** Conversion grossière HTML → texte pour citer un mail dont seul body_html existe. */
export function htmlToText(html: string): string {
  return html
    .replace(/<(style|script)[\s\S]*?<\/\1>/gi, '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|tr|li|h[1-6]|blockquote)>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#(\d+);/g, (_m, n: string) => String.fromCharCode(Number(n)))
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function buildReplyMailto(email: ReplySource): string {
  const headerLines = ['', '', '________________________________', `De : ${email.from_email}`];
  if (email.sent_at) headerLines.push(`Envoyé : ${new Date(email.sent_at).toLocaleString('fr-FR')}`);
  headerLines.push(`Objet : ${email.subject ?? '(sans objet)'}`, '');
  const header = headerLines.join('\n');

  const history = (email.body_text ?? '').trim() || (email.body_html ? htmlToText(email.body_html) : '');
  const prefix = `mailto:${email.from_email}?subject=${encodeURIComponent(replySubject(email.subject))}&body=`;

  let quoted = history;
  let url = prefix + encodeURIComponent(header + quoted);
  while (url.length > MAX_MAILTO_LENGTH && quoted.length > 0) {
    quoted = quoted.slice(0, Math.max(0, quoted.length - 200));
    url = prefix + encodeURIComponent(header + quoted + TRUNCATION_NOTICE);
  }
  return url;
}
